import { TagIcon, ArrowRightIcon, CheckIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import dubaiSkyline from "../assests/images/dubai-skyline.webp";

export default function LimitedTimeOffer() {
    const navigate = useNavigate();

    return (
        <section className="w-full bg-white py-12 sm:py-14 lg:py-16">
            <div className="mx-auto  max-w-[1536px]
              px-4
            sm:px-6
            lg:px-8">

                {/* Main Offer Card */}
                <div
                    className="
                        group
                        relative
                        overflow-hidden
                        rounded-2xl
                        border
                        border-[#DFE8ED]
                        bg-[#062F4F]
                        shadow-[0_12px_40px_rgba(6,47,79,0.12)]
                        transition-all
                        duration-500
                        hover:shadow-[0_18px_50px_rgba(6,47,79,0.18)]
                    "
                >

                    {/* Decorative Circle */}
                    <div
                        className="
                            pointer-events-none
                            absolute
                            -left-24
                            -top-24
                            h-64
                            w-64
                            rounded-full
                            border-[35px]
                            border-white/[0.04]
                        "
                    />

                    <div
                        className="
                            pointer-events-none
                            absolute
                            -bottom-32
                            left-[40%]
                            h-72
                            w-72
                            rounded-full
                            border-[40px]
                            border-[#F7B928]/[0.05]
                        "
                    />

                    <div className="relative grid lg:grid-cols-[1fr_0.9fr]">

                        {/* =========================
                            LEFT CONTENT
                        ========================== */}
                        <div className="relative flex flex-col justify-center px-6 py-10 sm:px-9 sm:py-12 lg:px-12 xl:px-14">

                            <div className="relative z-10 max-w-xl">

                                {/* Offer Label */}
                                <div
                                    className="
                                        mb-5
                                        inline-flex
                                        items-center
                                        gap-2.5
                                        rounded-full
                                        border
                                        border-[#F7B928]/30
                                        bg-white/[0.07]
                                        px-3.5
                                        py-2
                                    "
                                >
                                    <span
                                        className="
                                            flex
                                            h-7
                                            w-7
                                            items-center
                                            justify-center
                                            rounded-full
                                            bg-[#F7B928]
                                        "
                                    >
                                        <TagIcon className="h-3.5 w-3.5 text-[#062F4F]" />
                                    </span>

                                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#F7B928]">
                                        Limited Time Offer
                                    </span>
                                </div>

                                {/* Eyebrow */}
                                <div className="mb-3 flex items-center gap-3">
                                    <span className="h-[2px] w-8 bg-[#F7B928]" />

                                    <span className="text-[10px] font-semibold uppercase tracking-[0.18em] text-white/55">
                                        Exclusive Dubai Hotel Deals
                                    </span>
                                </div>

                                {/* Heading */}
                                <h2
                                    className="
                                        text-3xl
                                        font-extrabold
                                        leading-tight
                                        tracking-tight
                                        !text-white
                                        sm:text-4xl
                                        lg:text-[42px]
                                    "
                                >
                                    Make Your Dubai Stay
                                    <span className="block text-[#F7B928]">
                                        More Rewarding.
                                    </span>
                                </h2>

                                {/* Description */}
                                <p className="mt-4 max-w-lg text-sm leading-7 text-white/65 sm:text-[15px]">
                                    Discover handpicked hotels across Dubai and
                                    enjoy exclusive rates designed to make your
                                    next stay more memorable.
                                </p>

                                {/* Trust Points */}
                                <div className="mt-6 grid grid-cols-1 gap-2.5 sm:grid-cols-2">

                                    <div className="flex items-center gap-2 text-xs text-white/75">
                                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0B6E8E]">
                                            <CheckIcon className="h-3 w-3 text-white" />
                                        </span>
                                        Verified Hotels
                                    </div>

                                    <div className="flex items-center gap-2 text-xs text-white/75">
                                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0B6E8E]">
                                            <CheckIcon className="h-3 w-3 text-white" />
                                        </span>
                                        Best Local Rates
                                    </div>

                                    <div className="flex items-center gap-2 text-xs text-white/75">
                                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0B6E8E]">
                                            <CheckIcon className="h-3 w-3 text-white" />
                                        </span>
                                        Secure Booking
                                    </div>

                                    <div className="flex items-center gap-2 text-xs text-white/75">
                                        <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#0B6E8E]">
                                            <CheckIcon className="h-3 w-3 text-white" />
                                        </span>
                                        Local Support
                                    </div>

                                </div>

                                {/* CTA */}
                                <div className="mt-7 flex flex-col gap-4 sm:flex-row sm:items-center">

                                    <button
                                        type="button"
                                        onClick={() => navigate("/hotels")}
                                        className="
                                            group/button
                                            inline-flex
                                            w-fit
                                            items-center
                                            justify-center
                                            gap-2.5
                                            rounded-xl
                                            bg-[#FF5A1F]
                                            px-6
                                            py-3.5
                                            text-sm
                                            font-bold
                                            text-white
                                            shadow-[0_8px_25px_rgba(255,90,31,0.25)]
                                            transition-all
                                            duration-300
                                            hover:bg-[#e94d16]
                                            hover:shadow-[0_12px_30px_rgba(255,90,31,0.32)]
                                            active:scale-[0.98]
                                        "
                                    >
                                        <span>Explore Offers</span>

                                        <ArrowRightIcon
                                            className="
                                                h-4
                                                w-4
                                                transition-transform
                                                duration-300
                                                group-hover/button:translate-x-1
                                            "
                                        />
                                    </button>

                                    <span className="text-xs text-white/45">
                                        Exclusive rates • Secure booking
                                    </span>

                                </div>

                            </div>
                        </div>

                        {/* =========================
                            RIGHT IMAGE
                        ========================== */}
                        <div className="relative min-h-[300px] overflow-hidden lg:min-h-[430px]">

                            <img
                                src={dubaiSkyline}
                                alt="Dubai skyline"
                                className="
                                    absolute
                                    inset-0
                                    h-full
                                    w-full
                                    object-cover
                                    object-center
                                    transition-transform
                                    duration-1000
                                    group-hover:scale-105
                                "
                            />

                            {/* Overlay */}
                            <div className="absolute inset-0 bg-gradient-to-r from-[#062F4F]/55 via-[#062F4F]/10 to-transparent" />

                            <div className="absolute inset-0 bg-gradient-to-t from-[#062F4F]/45 via-transparent to-transparent" />

                            {/* =========================
                                DISCOUNT BADGE
                            ========================== */}
                            <div
                                className="
                                    absolute
                                    right-5
                                    top-5
                                    flex
                                    h-[110px]
                                    w-[110px]
                                    flex-col
                                    items-center
                                    justify-center
                                    rounded-full
                                    border
                                    border-white/70
                                    bg-white/95
                                    text-center
                                    shadow-[0_12px_35px_rgba(0,0,0,0.20)]
                                    sm:right-7
                                    sm:top-7
                                    sm:h-[125px]
                                    sm:w-[125px]
                                "
                            >
                                <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#FF5A1F]">
                                    Save Up To
                                </span>

                                <span className="mt-1 text-3xl font-extrabold leading-none text-[#062F4F] sm:text-4xl">
                                    40%
                                </span>

                                <span className="mt-1 text-[9px] font-semibold uppercase tracking-[0.1em] text-slate-500">
                                    Selected Stays
                                </span>
                            </div>

                            {/* =========================
                                BOTTOM IMAGE LABEL
                            ========================== */}
                            <div className="absolute bottom-5 left-5 right-5 sm:bottom-7 sm:left-7 sm:right-7">

                                <div
                                    className="
                                        flex
                                        items-center
                                        justify-between
                                        gap-4
                                        rounded-xl
                                        border
                                        border-white/20
                                        bg-[#062F4F]/55
                                        px-4
                                        py-3.5
                                        backdrop-blur-md
                                    "
                                >
                                    <div>
                                        <p className="text-lg font-bold text-white">
                                            Dubai Awaits
                                        </p>

                                        <p className="mt-0.5 text-[9px] font-medium uppercase tracking-[0.14em] text-white/60">
                                            Great stays • Better rates
                                        </p>
                                    </div>

                                    <div
                                        className="
                                            flex
                                            h-9
                                            w-9
                                            shrink-0
                                            items-center
                                            justify-center
                                            rounded-full
                                            bg-[#F7B928]
                                            text-[#062F4F]
                                        "
                                    >
                                        <ArrowRightIcon className="h-4 w-4" />
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </section>
    );
}